module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-easel-1243aa9a.svg";